export const getEnvironmentSpecificConstant = (envMap, envName, defaultValue) =>
  envMap[envName] || defaultValue;
